import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'configuraciones/acreedores-datos-de-pago';

/**
 * GET Acreedores Datos de Pago
 * @param {object} values
 * @returns {Promise<object[]>}
 */
export const getAcreedoresDatosDePago = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Acreedor Dato de Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAcreedorDatoDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Acreedor Dato de Pago
 * @param {object} values\
 * @returns {Promise<object|boolean>}
 */
export const postAcreedorDatoDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Acreedor Dato de Pago
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAcreedorDatoDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Acreedor Dato de Pago
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAcreedorDatoDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
